import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import toys from '../assets/toys.png';
import spinner from '../assets/spinner.svg';
import { convertImageIdToSrcSet } from '../util/functions';
import { ScreenSizesPx } from '../util/styles';

export type CarouselImage = {
  id: string;
  url?: string;
  alt: string;
};

const NoImage: CarouselImage = {
  id: '',
  url: toys,
  alt: 'Sem imagem.',
};

const Loading: CarouselImage = {
  id: '',
  url: spinner,
  alt: 'Carregando imagens',
};

const ScCarousel = styled.div`
  display: flex;
  flex-direction: column;
  width: calc(100%-30px);
  align-items: center;

  .main-image {
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    max-width: 400px;
    @media screen and (min-width: ${ScreenSizesPx.medium}px) {
      max-width: 600px;
    }

    @media screen and (min-width: ${ScreenSizesPx.large}px) {
      max-width: 800px;
    }

    .hide {
      visibility: hidden;
    }

    .prev,
    .next {
      color: white;
      font-size: 6em;
      user-select: none;
      width: 52px;
    }

    .prev {
      text-shadow: 1px 0px 1px #0000008c;
    }

    .next {
      text-shadow: -1px 0px 1px #0000008c;
    }

    img {
      height: 200px;
      @media screen and (min-width: ${ScreenSizesPx.medium}px) {
        height: 250px;
      }

      @media screen and (min-width: ${ScreenSizesPx.large}px) {
        height: 350px;
      }
      max-width: calc(100% - 104px);
    }
  }
`;

export const Carousel = ({ imagesIds }: { imagesIds: CarouselImage[] }) => {
  const [currentImage, setCurrentImage] = useState<CarouselImage>(Loading);

  useEffect(() => {
    if (imagesIds.length === 0) return setCurrentImage(NoImage);

    setCurrentImage(imagesIds[0]);
  }, [imagesIds]);

  const nextImage = (isNext: boolean) => {
    const imgIdx = imagesIds.indexOf(currentImage);
    const nextImg = (imgIdx + (isNext ? 1 : -1)) % imagesIds.length;
    setCurrentImage(imagesIds[nextImg < 0 ? imagesIds.length - 1 : nextImg]);
  };

  return (
    <ScCarousel>
      <div className="main-image">
        <div
          className={`prev ${imagesIds.length === 1 && 'hide'}`}
          onClick={() => nextImage(false)}
        >
          &lt;
        </div>
        <img
          srcSet={
            currentImage.id ? convertImageIdToSrcSet(currentImage.id) : ''
          }
          alt={currentImage.alt}
          sizes="(min-width: 992px) 350px, 200px"
        />
        <div
          className={`next ${imagesIds.length === 1 && 'hide'}`}
          onClick={() => nextImage(true)}
        >
          &gt;
        </div>
      </div>
    </ScCarousel>
  );
};
